<template>
  <svg
    overflow="visible"
    ref='postitContainer'
    :viewBox="`0 0 ${highlight ? (250* 2):250} ${highlight ? (height* 2):height}`"
    :width="highlight ? (250* 2):250"
    :height="highlight ? (height* 2):height"
    @click.ctrl="pushIdToParent()"
    v-if="(this.etat !== 'poubelle' && this !== undefined)"
    opacity="1"
    :id="'postitnumber'+this.id"
    :class="['groupPostit', (currentSheet !== this.sheet_id) ? 'hide' : '']"
    :x="`${post.folder_id ?0: (highlight ? this.post.coord_x - 125:this.post.coord_x)}px`"
    :y="`${post.folder_id ?0: (highlight ? this.post.coord_y - 30:this.post.coord_y)}px`"
    class="touchActionNone"
    fill="white"
  >
    <!-- :transform="highlight ? `translate(${this.x - 125 }, ${this.y - 30})` : `translate(${this.x}, ${this.y})`" -->
    <filter
      id="dropshadow"
      height="130%"
    >
      <feGaussianBlur
        in="SourceAlpha"
        stdDeviation="3"
      /> <!-- stdDeviation is how much to blur -->
      <feOffset
        dx="2"
        dy="2"
        result="offsetblur"
      /> <!-- how much to offset -->
      <feComponentTransfer>
        <feFuncA
          type="linear"
          slope="0.5"
        /> <!-- slope is the opacity of the shadow -->
      </feComponentTransfer>
      <feMerge>
        <feMergeNode /> <!-- this contains the offset blurred image -->
        <feMergeNode in="SourceGraphic" /> <!-- this contains the element that the filter is applied to -->
      </feMerge>
    </filter>
    <!-- Contenu du postit -->
    <g
      :stroke="'none'"
      :stroke-width="'0'"
      :transform="highligther()"
      :id="'postgroup'+this.id"
      :ref="'postgroup'+this.id"
      :class="this.hasFilteredColor && this.hasFilteredColor != couleur ? 'noCursor' :'postit'"
    >
      <rect
        ref="rectPost"
        id="rectPost"
        x="0"
        y="0"
        width="250"
        :style="'fill:#ffffff;'"
      />

      <text
        stroke="none"
        id="creationDate"
        ref="creationDate"
        :x="6"
        :y="20"
        font-family="Verdana"
        font-size="9"
        font-style="italic"
        fill="grey"
      >{{displayDate}}</text>

      <text
        stroke="none"
        ref="textPost"
        :x="0"
        :y="0"
        font-family="Verdana"
        font-size="11"
        fill="black"
      ></text>

      <rect
        id="colorRibbon"
        :style="'fill:' + this.couleur+ ';'"
        x="0"
        y="0"
        width="250"
        height="6"
        stroke-width="0"
      />
      <!-- <foreignObject
        v-if="$route.name === 'animer' || current.mode==='libre'"
        @click.exact="toggleMenu()"
        x="215"
        class="disableDrag"
        y="10"
        width="30"
        height="30"
        style="line-height: 20px;"
      >
        <div id="toggleMenuIconBackground">

        </div>
      </foreignObject> -->
      <foreignObject
        v-if="$route.name === 'animer' || current.mode==='libre' && !boardIsClosed"
        v-touch="toggleMenu"
        x="215"
        class="disableDrag"
        y="10"
        width="30"
        height="30"
        style="line-height: 20px;"
      >
        <b-icon
          id="toggleMenuIcon"
          class="editbutton disableDrag"
          pack="fas"
          icon="ellipsis-h"
          size="is-small"
        ></b-icon>
      </foreignObject>
      <foreignObject
        v-if="isMenuOpen"
        :x="'240'"
        :y="'15'"
        width="380"
        height="105"
        class="disableDrag"
        style="line-height: 20px;"
      >
        <div
          id="menuContainer"
          class="disableDrag"
        >
          <div
            class="menuItem disableDrag"
            id="edit"
            @click="editPost(id)"
          >
            <span>{{$t('editPost')}}</span>
            <b-icon
              class="rightAlign"
              pack="fas"
              icon="edit"
              size="is-small"
            ></b-icon>

          </div>
          <!-- <div
            class="disableDrag"
            v-if="current.sheets.length > 1 &&
            (this.post.folder_id === undefined || this.post.folder_id === null)"
            @click="()=>{forceSheetOpen = !forceSheetOpen}"
            @mouseenter="showSheetList(true)"
            @mouseleave="showSheetList(false)"
            id="changeSheet"
          >
            <div
              class="menuItem disableDrag"
              style="width:85px;"
            ><span class="disableDrag">{{$t('changeSheet')}}</span>
              <b-icon
                class="rightAlign"
                pack="fas"
                icon="angle-right"
                size="is-small"
              ></b-icon>
            </div>
            <div
              class="disableDrag"
              v-if="isSheetListShown || forceSheetOpen"
              id="sheetList"
            >
              <div
                class="sheetListItem"
                v-for="(sheet, key) in this.current.sheets"
                :key="key"
                v-if="sheet.id !== currentSheet"
                @click="changeSheet(sheet.id)"
              > {{sheet.name}}</div>
            </div>
          </div> -->
          <div
            v-if="this.post.folder_id === undefined || this.post.folder_id === null"
            @click="deletePost"
            class="menuItem disableDrag"
            id="delete"
          ><span class="disableDrag">{{$t('delete')}}</span>
            <b-icon
              class="rightAlign disableDrag"
              pack="far"
              icon="trash-alt"
              size="is-small"
            ></b-icon>
          </div>
        </div>

      </foreignObject>
    </g>

    <!-- Bouton Liens externe trombone-->
    <svg
      id="bottomContainer"
      :width="highlight ? 250* 2:250  "
      :height="highlight ? 25* 2:25  "
      :y="highlight ? (height - 22)* 2:height - 22"
    >
      <g
        id="externalLink"
        stroke="none"
        :transform="highligther()"
        :class="{non_active: !this.post.link}"
      >
        <a @click.exact="openPopupLink(id)">
          <foreignObject
            x="1"
            y="0"
            width="20"
            height="20"
            style="line-height: 20px;"
          >
            <b-icon
              class="editbutton"
              pack="fas"
              icon="link"
              size="is-small"
            ></b-icon>
          </foreignObject>
        </a>
      </g>

      <!-- Bouton image -->
      <g
        id="openPicture"
        stroke="none"
        :transform="highligther()"
        :class="{non_active: !this.media}"
      >
        <a @click.exact="loadImagePopup(url_media+'uploads/brainstorming/medias/'+media)">
          <foreignObject
            x="23"
            y="0"
            width="20"
            height="20"
            style="line-height: 20px;"
          >
            <img
              id="addPhoto"
              src="/static/add_photo.png"
              alt=""
            />
          </foreignObject>
        </a>
      </g>

      <!-- Bouton "J'aime" -->
      <g
        :transform="highligther()"
        stroke="none"
        id="likesGroup"
        v-if="!boardIsClosed"
      >
        <a @click.exact="likePost(id)">
          <g
            transform="translate(48, 1)"
            width="20"
            height="20"
            style="line-height: 20px;"
          >
            <thumbsUpBlack class="svgIcon" />
          </g>
          <foreignObject
            x="48"
            y="0"
            width="20"
            height="20"
          >
            <div id="likesGroupBackground"></div>
          </foreignObject>
          <text
            x="65"
            y="15"
            width="20"
            height="20"
            font-size="12"
            fill="black"
          >{{ this.like }}</text>
        </a>
      </g>

      <!-- Boutons actions pour administrateur -->
      <g
        id="bottomRightSettings"
        stroke="none"
        :transform="highligther()"
      >
        <foreignObject
          @click.exact="selectAllLinked(id)"
          x="200"
          y="0"
          width="18px"
          height="18px"
          style="line-height: 20px;"
        >
          <img
            v-show="isLinked"
            :title="$t('title.showLinked')"
            class="linkEditButton"
            src="/static/logo_liaison.png"
            alt=""
            width="18"
            height="18"
          >
        </foreignObject>
        <foreignObject
          @click.exact="switchHighlight()"
          x="220"
          y="0"
          width="20"
          height="20"
          style="line-height: 20px;"
          v-if="
            (this.post.folder_id === undefined || this.post.folder_id === null) && !boardIsClosed"
        >
          <b-icon
            v-if="!highlight"
            class="editbutton"
            pack="fas"
            icon="search-plus"
            size="is-small"
          ></b-icon>
          <b-icon
            v-if="highlight"
            class="editbutton"
            pack="fas"
            icon="search-minus"
            size="is-small"
          ></b-icon>
        </foreignObject>
      </g>
      <!-- <foreignObject
            @click.exact="deletePost(id)"
            x="220"
            y="0"
            width="18"
            height="18"
            style="line-height: 18px;"
          >
            <b-icon
              class="editbutton"
              pack="fas"
              icon="trash-alt"
              size="is-small"
            ></b-icon>
          </foreignObject> -->

      <!-- Bouton de modification pour tous (en Libre uniquement) -->
      <!-- <g
        stroke="none"
        :transform="highligther()"
      >
        <foreignObject
          @click.exact="editPost(id)"
          x="220"
          y="0"
          width="20"
          height="20"
          style="line-height: 20px;"
        >
          <b-icon
            class="editbutton"
            pack="fas"
            icon="cog"
            size="is-small"
          ></b-icon>
        </foreignObject>
      </g> -->
    </svg>
    <g
      v-for="(pos, key) in bitonio"
      :key='key'
      :id="'bitonio'+key"
      :transform="pos.transform"
      @click.left.exact="(e)=>{linkPost(e, key)}"
      v-show="(menu.linkSimple ||menu.linkHier) && post.folder_id === null"
    >
      <g
        style="display:inline"
        id="layer1"
      >
        <ellipse
          transform="scale(1,-1)"
          ry="10.677828"
          rx="10.725074"
          cy="-13.21547"
          cx="13.751432"
          id="path3715"
          style="fill:#f2f2f2;stroke-width:0.26458332"
        />
      </g>
      <g id="layer2">

        <circle
          :style="`fill:${couleur};stroke-width:0.26458332`"
          r="6.0476193"
          cy="13.21547"
          cx="13.751432"
          id="path3713"
        />
        <line
          :key="key+'Line'"
          id="linkCreateLine"
          x1="13"
          y1="13"
          :x2="endOfLine(key).x"
          :y2="endOfLine(key).y"
          :style="`stroke:${$parent.lineColor}; stroke-width:2.5;`"
          v-if="id !== -1 && linking.isLinking && linking.currentChild === id && clickedBitonio === key"
        />

      </g>
    </g>
    <rect
      rx="5"
      ry="5"
      :transform="highligther()"
      :opacity="'1'"
      :fill="'none'"
      :stroke=" this.$parent.selectedPosts && this.$parent.selectedPosts.includes(this.id)? '#424a60':'none'"
      :stroke-width=" this.$parent.selectedPosts && this.$parent.selectedPosts.includes(this.id)? '3':'0'"
      x="0"
      y="0"
      :width="width"
      :height="height"
    />
  </svg>
</template>

<script>
import interact from 'interactjs'
import thumbsUpBlack from '../../assets/svg/thumbsUpBlack.svg'

import { createNamespacedHelpers } from 'vuex'
const { mapState } = createNamespacedHelpers('board')
export default {

  name: 'post',
  components: {
    thumbsUpBlack
  },
  data () {
    return {
      forceSheetOpen: false,
      isSheetListShown: false,
      isLinked: false,
      isMenuOpen: false,
      filteredFromLinks: false,
      editPostLinkActive: false,
      clickedBitonio: '',
      id: -1,
      x: 0,
      y: 0,
      width: 250,
      height: 0,
      posBeforeMove: {
        x: -1,
        y: -1
      },
      contenu: '',
      like: 0,
      couleur: '',
      folder_id: null,
      sheet_id: null,
      etat: 'attente',
      opacity: 1,
      moving: false,
      clientX: 0,
      clientY: 0,
      url_media: process.env.URL_MEDIA,
      link: '',
      messagePopup: '',
      lastKnownScrollPosition: { x: 0, y: 0 },
      ticking: false,
      highlight: false
    }
  },
  props: {
    post: {
      type: Object,
      required: true
    },
    hasFilteredColor: String,
    selected: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    disableMove () {
      if (this.current.mode === 'moderee' && this.$route.params.url_participant) {
        return true
      }
      return false
    },
    displayDate () {
      function formatedMonth (date) {
        var month = date.getMonth() + 1
        return month < 10 ? '0' + month : '' + month // ('' + month) for string result
      }
      function formatedDay (date) {
        var day = date.getDate()
        return day < 10 ? '0' + day : '' + day // ('' + month) for string result
      }
      function formatedHours (date) {
        var hour = date.getHours() + 1
        return hour < 10 ? '0' + hour : '' + hour // ('' + month) for string result
      }
      function formatedMinutes (date) {
        var minute = date.getMinutes() + 1
        return minute < 10 ? '0' + minute : '' + minute // ('' + month) for string result
      }
      let creationEpoch = new Date(Date.parse(this.post.created_at.replace(/\s/, 'T'))) // Le 'replace 'T' sert à formatter la date pour que safari puisse la lire correctement) // Le 'replace 'T' sert à formatter la date pour que safari puisse la lire correctement
      return `${formatedDay(creationEpoch)}/${formatedMonth(creationEpoch)}/${creationEpoch.getFullYear()} - ${formatedHours(creationEpoch)}:${formatedMinutes(creationEpoch)}`
    },
    autoPositionBottomCont () {
      if (this.height) {
        return this.height - 20
      }
      return 60 - 20
    },
    autoSizeSVG () {
      if (this.height) {
        return this.height
      }
      return 60
    },
    bitonio () {
      if (this.height) {
        return {
          up: {
            transform: `translate(${110 + (110 * this.highlight)},-23) `
          },
          right: {
            transform: `translate(${this.highlight ? (this.width - 3) * 2 : this.width - 3},17) `
          },
          down: {
            transform: `translate(${110 + (110 * this.highlight)},${this.highlight ? (this.height - 3) * 2 : this.height - 3}) `
          },
          left: {
            transform: `translate(-23,17) `
          }
        }
      } else {
        return {
          up: {
            transform: 'translate(110,-23) '
          },
          right: {
            transform: 'translate(245,17) '
          },
          down: {
            transform: `translate(110,60) `
          },
          left: {
            transform: 'translate(-23,17) '
          }
        }
      }
    },
    anchors () {
      if (this.menu.linkHier || this.menu.linkSimple) {
        let ellipseWidth = 13

        if (this.highlight) {
          return {
            up: { x: 95 + this.x + ellipseWidth, y: -58 + this.y + ellipseWidth },
            right: { x: this.width + 128 + this.x + ellipseWidth, y: -ellipseWidth + this.y + ellipseWidth },
            down: { x: 95 + this.x + ellipseWidth, y: this.height + 32 + this.y + ellipseWidth },
            left: { x: -153 + this.x + ellipseWidth, y: -ellipseWidth + this.y + ellipseWidth }
          }
        } else {
          return {
            up: { x: 110 + this.x + ellipseWidth, y: -28 + this.y + ellipseWidth },
            right: { x: this.width + 3 + this.x + ellipseWidth, y: 17 + this.y + ellipseWidth },
            down: { x: 110 + this.x + ellipseWidth, y: this.height + 2 + this.y + ellipseWidth },
            left: { x: -28 + this.x + ellipseWidth, y: 17 + this.y + ellipseWidth }
          }
        }
      } else {
        let ellipseWidth = 0

        if (this.highlight) {
          return {
            up: { x: 95 + this.x + ellipseWidth, y: -58 + this.y + ellipseWidth },
            right: { x: this.width + 128 + this.x + ellipseWidth, y: -ellipseWidth + this.y + ellipseWidth },
            down: { x: 95 + this.x + ellipseWidth, y: this.height + 32 + this.y + ellipseWidth },
            left: { x: -153 + this.x + ellipseWidth, y: -ellipseWidth + this.y + ellipseWidth }
          }
        } else {
          return {
            up: { x: 110 + this.x + ellipseWidth, y: -2 + this.y + ellipseWidth },
            right: { x: this.width + 3 + this.x + ellipseWidth, y: 17 + this.y + ellipseWidth },
            down: { x: 110 + this.x + ellipseWidth, y: this.height + 2 + this.y + ellipseWidth },
            left: { x: 0 + this.x + ellipseWidth, y: 17 + this.y + ellipseWidth }
          }
        }
      }
    },

    ...mapState({
      currentSheet: 'currentSheet',
      current: 'current',
      menu: 'menu',
      postlist: 'currentBoardPost',
      linking: 'linking',
      boardIsClosed: "boardIsClosed"
    })
  },
  mounted () {
    document.querySelector('#boardMeeting').addEventListener('scroll', (e) => {
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          this.followScroll(document.querySelector('#boardMeeting').scrollTop, document.querySelector('#boardMeeting').scrollLeft)
          this.ticking = false
        })

        this.ticking = true
      }
    })
    this.wrapTextRect()

    if (
      this.etat === 'publie' &&
      this.$store.state.board.current.mode !== 'moderee'
    ) {
      var el = document.getElementById('postgroup' + this.id)
      el.addEventListener('touchstart', this.startTouchMove, false)

      // à chaque réception de postit on regarde si il y a un filtre en cours sur la couleur et on adapte le cas échéant l'opacity
      if (this.hasFilteredColor && this.hasFilteredColor != this.couleur) {
        document.getElementById('postitnumber' + this.id).setAttribute('opacity', 0.2)
        document.getElementById('postitnumber' + this.id).style.cursor = 'default'
        document.getElementById('postitnumber' + this.id).childNodes[0].style.cursor = 'default'
      }
    }
    setTimeout(() => {
      this.checkIsLinked()
    }, 500)

    if (this.$store.state.board.current.mode !== 'moderee' || this.$route.name === 'animer') {
      let myDraggable = this.$refs.postitContainer

      this.initInteract(myDraggable)
    }
  },
  updated () {
    //this.wrapTextRect()
  },
  watch: {

    post: {
      handler (post) {
        this.id = post.id
        this.x = (post.coord_x > 0 && post.coord_x < 3840) ? post.coord_x : post.coord_x % 3840
        this.y = (post.coord_y > 0 && post.coord_y < 2160) ? post.coord_y : post.coord_y % 2160
        this.contenu = post.contenu
        this.like = post.like
        this.couleur = post.couleur
        this.etat = post.etat
        this.media = post.media
        this.link = post.link
        this.opacity = post.opacity
        this.sheet_id = post.sheet_id
        this.folder_id = post.folder_id
        this.checkIsLinked()

        if (
          this.etat === 'publie' &&
          this.$refs.rectPost !== undefined &&
          this.$refs.textPost !== undefined
        ) {
          this.wrapTextRect()
        }
      },
      deep: true,
      immediate: true
    }
    // moving: {
    //   handler () {
    //     if (this.moving) {
    //       this.move()
    //     }
    //   },
    //   deep: true,
    //   immediate: true
    // }
  },
  methods: {
    followScroll (y, x) {
      if (this.moving) {
        this.post.coord_y += y - this.lastKnownScrollPosition.y
        this.post.coord_x += x - this.lastKnownScrollPosition.x
      }
      this.lastKnownScrollPosition.y = y
      this.lastKnownScrollPosition.x = x
    },
    initInteract (selector) {
      // interact.dynamicDrop(true)
      interact(selector).draggable({
        // enable inertial throwing
        inertia: false,
        ignoreFrom: '.disableDrag',
        // keep the element within the area of it's parent
        // modifiers: [
        //   interact.modifiers.restrictRect({
        //     restriction: document.querySelector('#svgBoard'),
        //     elementRect: { left: 0, right: 0, top: 1, bottom: 1 },
        //     endOnly: false
        //   })
        // ],
        // restrictRect: {
        //   restriction: selector.parentElement,
        //   elementRect: { left: 0, right: 0, top: 1, bottom: 1 },
        //   endOnly: true
        // },
        // enable autoScroll
        // autoScroll: true,
        enabled: this.post.folder_id === null || this.post.folder_id === undefined,
        autoScroll: {
          container: document.querySelector('#boardMeeting'),
          margin: 50,
          distance: 5,
          interval: 10,
          speed: 500
        },

        // call this function on every dragmove event
        onmove: this.dragMoveListener,
        // call this function on every dragend event
        onend: this.releasedPost
      })
    },
    dragMoveListener (event) {
      // console.log('post moves')
      // let target = event.target
      // keep the dragged position in the data-x/data-y attributes

      this.moving = true

      this.post.coord_x = this.post.coord_x + event.dx
      this.post.coord_y = this.post.coord_y + event.dy

      if (this.post.coord_x < 0) {
        this.post.coord_x = 0
      }
      if (this.post.coord_x > 3840 - event.target.children[1].getBoundingClientRect().width) {
        this.post.coord_x = 3840 - event.target.children[1].getBoundingClientRect().width
      }

      if (this.post.coord_y < 0) {
        this.post.coord_y = 0
      }
      if (this.post.coord_y > 2160 - event.target.children[1].getBoundingClientRect().height) {
        this.post.coord_y = 2160 - event.target.children[1].getBoundingClientRect().height
      }

      if (this.selected && this.$parent.selectedPosts.length > 1) {
        // console.log('moving', { movedX: event.dx, movedY: event.dy, id: this.post.id })
        this.$emit('moving', { movedX: event.dx, movedY: event.dy, id: this.post.id })
      }
    },
    releasedPost (e) {
      // console.log(e)
      this.moving = false
      // this.mouseUp(e)
      if (!this.disableMove) {
        // this.post.coord_x = parseInt(this.post.coord_x + e.totalDist.x)
        // this.post.coord_y = parseInt(this.post.coord_y + e.totalDist.y)
        if ((!this.selected || this.$parent.selectedPosts.length === 1) && (!e.relatedTarget || !e.relatedTarget.id.includes('folder'))) {
          this.updatePost(this.post)
        } else {
          this.$emit('stopped')
        }
      }
    },
    updatePost (post) {
      this.$store.dispatch('board/updatePostData', {
        board: this.$store.state.board.current,
        post: post
      })
    },
    changeSheet (sheetId) {
      let post = this.post
      post.sheet_id = sheetId

      this.$store.dispatch('board/updatePostData', {
        board: this.$store.state.board.current,
        post: post
      })
      this.isSheetListShown = false
      this.forceSheetOpen = false
      this.isMenuOpen = false
    },
    showSheetList (showing) {
      this.isSheetListShown = showing
    },
    toggleMenu (e, setter = !this.isMenuOpen) {
      if (this.$parent.$refs.post) {
        this.$parent.$refs.post.forEach(post => {
          if (post.post.id !== this.post.id) {
            post.isMenuOpen = false
          }
        })
      } else if (this.$parent.$parent.$parent.$refs.post) {
        this.$parent.$parent.$parent.$refs.post.forEach(post => {
          if (post.post.id !== this.post.id) {
            post.isMenuOpen = false
          }
        })
      }
      // console.log('toggle fired')
      this.isMenuOpen = setter
    },
    checkIsLinked () {
      if (this.$parent.$refs.link &&
        this.$parent.$refs.link.filter(link => {
          return link.link.parent_post === this.post.id || link.link.child_post === this.post.id
        }).length > 0) {
        this.isLinked = true
      } else {
        this.isLinked = false
      }
    },
    selectAllLinked (id) {
      if (this.filteredFromLinks) {
        this.$parent.$parent.filterColor(null)
        this.$parent.$refs.post.forEach(post => {
          post.filteredFromLinks = false
        })
      } else {
        let storedLinks = []
        let storedLinkedPosts = []
        let currentLinkedPosts = [id]
        while (currentLinkedPosts.length > 0) {
          let links = []

          currentLinkedPosts.forEach((linkedPost, index) => {
            let tempLinks = this.$parent.links.filter(link => {
              if (currentLinkedPosts.includes(link.parent_post) && currentLinkedPosts.includes(link.child_post)) {
                return false
              }
              if ((link.parent_post !== linkedPost) && (link.child_post !== linkedPost)) {
                return false
              }
              return true
            })
            links.push(...tempLinks)
          })

          storedLinkedPosts.push(...currentLinkedPosts)
          currentLinkedPosts = []
          links.forEach(link => {
            if (!(storedLinkedPosts.includes(link.child_post))) {
              currentLinkedPosts.push(link.child_post)
            }
            if (!(storedLinkedPosts.includes(link.parent_post))) {
              currentLinkedPosts.push(link.parent_post)
            }
            if (!(storedLinks.includes(link.id))) {
              storedLinks.push(link.id)
            }
          })
        }

        this.$parent.$refs.post.forEach(post => {
          if (storedLinkedPosts.includes(post.post.id)) {
            post.filteredFromLinks = true
          } else {
            post.filteredFromLinks = false
          }
        })

        this.postlist.forEach(linkedPost => {
          let domPost = document.getElementById('postitnumber' + linkedPost.id)
          domPost.setAttribute('opacity', 1)
          domPost.style.cursor = 'grab'
          domPost.childNodes[0].style.cursor = 'grab'
          if (!(storedLinkedPosts.includes(linkedPost.id))) {
            if (domPost) {
              domPost.setAttribute('opacity', 0.2)
              domPost.style.cursor = 'default'
              domPost.childNodes[0].style.cursor = 'default'
            }
          }
        })

        this.$parent.$refs.link.forEach(link => {
          if (storedLinks.includes(link.link.id)) {
            link.opacity = 1
          } else {
            link.opacity = 0.2
          }
        })
      }
    },
    editPostLink (id) {
      this.$parent.idPostLinkEdit = id
      this.$parent.editPostLinkActive = true
    },
    endOfLine (position) {
      // eslint-disable-next-line one-var
      let x = 0
      let y = 0
      let bitonioRadius = 10
      switch (position) {
        case 'up':

          x = this.$parent.mouseX - this.x - this.$parent.getWidthOffset() - (this.width / 2) + bitonioRadius// - 245 + 138
          y = this.$parent.mouseY - this.y - this.$parent.getHeightOffset() + 20
          break

        case 'right':
          x = this.$parent.mouseX - this.x - this.$parent.getWidthOffset() - this.width// - 245
          y = this.$parent.mouseY - this.y - this.$parent.getHeightOffset() - 20
          break

        case 'down':
          x = this.$parent.mouseX - this.x - this.$parent.getWidthOffset() - (this.width / 2) + bitonioRadius// - 245 + 138
          y = this.$parent.mouseY - this.y - this.$parent.getHeightOffset() - this.height// - 21 - 39

          break

        case 'left':

          x = this.$parent.mouseX - this.x - this.$parent.getWidthOffset() + 20
          y = this.$parent.mouseY - this.y - this.$parent.getHeightOffset() - 20
          break

        default:
          break
      }
      return { x: x, y: y }
    },
    getHeightOffset () {
      return this.$refs.svgBoard ? this.$refs.svgBoard.getBoundingClientRect().y : 0
    },
    linkPost (e, key) {
      this.clickedBitonio = key

      if (this.linking.currentChild === null) {
        this.$store.commit('board/CHANGE_LINK_PARENT', { type: 'child', idPost: this.id })
      } else if (this.linking.currentChild !== null && this.linking.currentParent === null && this.id !== this.linking.currentChild) {
        this.$store.commit('board/CHANGE_LINK_PARENT', { type: 'parent', idPost: this.id })

        let linkAlreadyExists = this.$parent.links.filter(link => {
          if ((link.child_post === this.linking.currentChild && link.parent_post === this.linking.currentParent) || (link.parent_post === this.linking.currentChild && link.child_post === this.linking.currentParent)) {
            return true
          } else {
            return false
          }
        })
        let relation = this.menu.linkHier ? 'inverse' : 'none'
        linkAlreadyExists.length === 0 ? this.$store.dispatch('board/createLink', { parent: this.linking.currentParent, child: this.linking.currentChild, relation: relation, sheet: this.sheet_id, color: this.$parent.lineColor, board: { id: this.post.board_id, url_participant: this.current.url_participant } }) : this.$store.commit('board/CREATE_LINK')
      } else {
        this.$store.commit('board/CREATE_LINK')
      }
      this.checkIsLinked()
    },
    wrapTextRect () {
      let myRect = this.$refs.rectPost
      let myText = this.$refs.textPost
      let textvalue = this.contenu
      var NS = 'http://www.w3.org/2000/svg'
      // ---clear previous---
      for (var k = myText.childNodes.length - 1; k >= 0; k--) {
        myText.removeChild(myText.childNodes.item(k))
      }

      var padding = 25
      var width = +myRect.getAttribute('width') - padding
      var x = 10
      var y = +myRect.getAttribute('y')
      var fontSize = +myText.getAttribute('font-size')
      var text = textvalue
      var words = text.split(' ')
      var textelement = myText
      var tspanelement = document.createElementNS(NS, 'tspan') // Create first tspan element
      var textnode = document.createTextNode(words[0]) // Create text in tspan element
      tspanelement.setAttribute('x', x)
      tspanelement.setAttribute('y', y + padding + fontSize + 15)
      tspanelement.appendChild(textnode) // Add tspan element to DOM
      textelement.appendChild(tspanelement) // Add text to tspan element
      var match = false

      for (var i = 1; i < words.length; i++) {
        var len = tspanelement.firstChild.data.length // Find number of letters in string
        tspanelement.firstChild.data += ' ' + words[i] // Add next word

        // match = /\r|\n/.exec(words[i])
        if (tspanelement.getComputedTextLength() > width - padding) {
          tspanelement.firstChild.data = tspanelement.firstChild.data.slice(0, len) // Remove added word

          tspanelement = document.createElementNS(NS, 'tspan') // Create new tspan element
          tspanelement.setAttribute('x', x)
          tspanelement.setAttribute('dy', fontSize)

          textnode = document.createTextNode(words[i])
          tspanelement.appendChild(textnode)
          textelement.appendChild(tspanelement)
        }

        match = /\r|\n/.exec(words[i])
        if (match) {
          var indexSautDeLigne = words[i].search(/\r|\n/)
          var newword = words[i].slice(indexSautDeLigne + 1, words[i].length)
          tspanelement.firstChild.data = tspanelement.firstChild.data.slice(
            0,
            len + indexSautDeLigne + 1
          ) // Remove added word

          tspanelement = document.createElementNS(NS, 'tspan') // Create new tspan element
          tspanelement.setAttribute('x', x)
          tspanelement.setAttribute('dy', fontSize)

          textnode = document.createTextNode(newword)
          tspanelement.appendChild(textnode)
          textelement.appendChild(tspanelement)
        }
      }

      var height = 25 + textelement.getBBox().height + 2 * padding // -- get height plus padding
      if (height < 60) { height = 60 }
      this.height = height
      myRect.setAttribute('height', height) // -- change rect height
    },
    pushIdToParent () {
      if (this.$store.state.board.current.mode === 'libre' ||
        this.$route.name === 'animer') {
        if (this.$parent.selectedPosts.includes(this.id)) {
          this.$parent.selectedPosts = this.$parent.selectedPosts.filter(postId => postId !== this.id)
        } else { this.$parent.selectedPosts.push(this.id) }
      }
    },
    switchHighlight () {
      this.highlight = !this.highlight
    },
    highligther (type = 'classic') {
      if (type === 'classic') {
        if (this.highlight) {
          return 'scale(2)'
        } else {
          return 'scale(1)'
        }
      } else if (type === 'webLink') {
        if (this.highlight) {
          return 'scale(1.6)'
        } else {
          return 'scale(0.8)'
        }
      }
    },
    sendMessageToParent (taskToDo) {
      let message = {
        task: taskToDo
      }
      window.top.postMessage(message, '*')
    },
    openPopupLink (id) {
      this.sendMessageToParent('scrollToTop')
      if (this.link.length > 40) { this.messagePopup = this.link.substr(0, 40) + '...' } else { this.messagePopup = this.link }
      this.$buefy.dialog.confirm({
        title: this.$i18n.t('post.link.popup.title'),
        message: this.$i18n.t('post.link.popup.message') + '<br><br>' + this.messagePopup,
        type: 'is-info',
        cancelText: this.$i18n.t('post.link.popup.non'),
        confirmText: this.$i18n.t('post.link.popup.oui'),
        hasIcon: true,
        onConfirm: () => window.open(this.link, '_blank')
      })
    },

    loadImagePopup (mediaURL) {
      this.sendMessageToParent('scrollToTop')
      this.$store.commit('board/SHOW_PICTURE', { 'url': mediaURL, 'open': true })
    },
    handleStart () {
      // alert('touch')
    },
    likePost (id) {
      this.like++
      this.$store.dispatch('board/updatePostData', { board: this.$store.state.board.current, post: this })
      this.$buefy.toast.open({
        message: this.$i18n.t('post.like.message'),
        type: 'is-info',
        position: 'is-bottom'
      })
    },
    move: function () {
      // document.documentElement.addEventListener('touchmove', this.handleMove, true)
      // document.documentElement.addEventListener('touchend touchcancel', this.deselect, true)
      // document.documentElement.addEventListener('touchstart', this.handleUp, true)
      var contain = document.getElementsByClassName('boardmeeting')[0]
      const m = this.move
      if ((contain.offsetWidth - this.clientX) < 50) {
        contain.scrollTo(contain.scrollLeft + 50, contain.scrollTop)
      } else if (this.clientX < 50) {
        contain.scrollTo(contain.scrollLeft - 50, contain.scrollTop)
      }
      if ((contain.offsetHeight - this.clientY) < 50) {
        contain.scrollTo(contain.scrollLeft, contain.scrollTop + 50)
      } else if (this.clientY < 200) {
        contain.scrollTo(contain.scrollLeft, contain.scrollTop - 50)
      }
      if (this.moving) {
        setTimeout(function () {
          m()
        }, 20)
      }
    },
    deletePost (id) {
      this.$buefy.dialog.confirm({
        cancelText: this.$i18n.t('button.annuler'),
        confirmText: this.$i18n.t('button.supprimer'),
        message: this.$i18n.t('post.supprimer.message'),
        onConfirm: () => this.deletepost()
      })
    },
    editPost (id) {
      this.toggleMenu('e', false)
      this.$store.commit('board/CHANGE_POST_COLOR', this.couleur)
      this.$store.commit('board/UPDATE_POST_POPUP', this.post)
      this.$store.commit('board/NEW_POST_POPUP_STATE', true)
    },
    deletepostFromParent () {
      this.etat = 'poubelle'
      this.$store.dispatch('board/updatePostData', {
        board: this.$store.state.board.current,
        post: this
      })
    },
    deletepost () {
      this.etat = 'poubelle'
      this.$store.dispatch('board/updatePostData', {
        board: this.$store.state.board.current,
        post: this
      })
      this.$buefy.toast.open({
        message: this.$i18n.t('post.supprimer.notification'),
        type: 'is-success',
        position: 'is-bottom'
      })
    },
    openLink () {
      window.open('https://www.google.com', '_blank')
    },
    switchColor () {
      if (this.deletebuttoncolor === 'red') { this.deletebuttoncolor = 'white' } else { this.deletebuttoncolor = 'red' }
    },
    getDistMoved () {
      if (!isNaN(this.x) && !isNaN(this.y) && !isNaN(this.posBeforeMove.x) && !isNaN(this.posBeforeMove.x)) {
        let movedX = this.x - this.posBeforeMove.x
        let movedY = this.y - this.posBeforeMove.y
        this.posBeforeMove.x = this.x
        this.posBeforeMove.y = this.y
        return { movedX, movedY }
      } else { return null }
    },
    commitFromParent () {
      this.$store.dispatch('board/updatePostData', {
        board: this.$store.state.board.current,
        post: this
      })
    },
    movedFromParent (x, y) {
      this.x += x
      if (this.x < 0) {
        this.x = 0
      }
      if (this.x + 250 > 3840) {
        this.x = 3840 - 250
      }
      this.y += y
      if (this.y < 0) {
        this.y = 0
      }
      if (this.y + 60 > 2160) {
        this.y = 2160 - 60
      }
      this.post.coord_x += x
      if (this.post.coord_x < 0) {
        this.post.coord_x = 0
      }
      if (this.post.coord_x + 250 > 3840) {
        this.post.coord_x = 3840 - 250
      }
      this.post.coord_y += y
      if (this.post.coord_y < 0) {
        this.post.coord_y = 0
      }
      if (this.post.coord_y + 60 > 2160) {
        this.post.coord_y = 2160 - 60
      }
    },
    startMove (evt) {
      if (
        (this.$store.state.board.current.mode === 'libre' ||
          this.$router.currentRoute.name === 'animer') &&
        // eslint-disable-next-line eqeqeq
        document.getElementById('postitnumber' + this.id).attributes.opacity.value == 1 &&
        (this.post.folder_id === undefined || this.post.folder_id === null)
      ) {
        let totalMoved = { x: 0, y: 0 }
        this.posBeforeMove.x = this.x
        this.posBeforeMove.y = this.y

        const elem = document.querySelector('#svgBoard')

        const getPos = this.getMousePos
        const dif = {}

        if (evt.clientX) {
          dif.x = evt.clientX - document.getElementById('svgBoard').getBoundingClientRect().left - this.x
        } else if (evt.changedTouches && evt.changedTouches[0]) {
          dif.x = evt.changedTouches[0].clientX
        }

        if (evt.clientY) {
          dif.y = evt.clientY - document.getElementById('svgBoard').getBoundingClientRect().top - this.y
        } else if (evt.changedTouches && evt.changedTouches[0]) {
          dif.y = evt.changedTouches[0].clientY
        }

        this.moving = true
        // const point = elem.createSVGPoint()
        const updateFn = () => {
          if (this.moving) requestAnimationFrame(updateFn)
        }
        const events = {
          move: 'mousemove',
          stop: 'mouseup'
        }
        const moveFn = evt => {
          getPos(evt, this, dif)
          let movedDist = this.getDistMoved()

          if (movedDist && !isNaN(movedDist.movedX)) {
            totalMoved.x += Math.abs(movedDist.movedX)
          }
          if (movedDist && !isNaN(movedDist.movedY)) {
            totalMoved.y += Math.abs(movedDist.movedY)
          }

          if (this.selected) {
            if (movedDist) {
              movedDist.id = this.id
              this.$emit('moving', movedDist)
            }
          }
          if (this.x < 0) {
            this.x = 0
          }
          if (this.x + 250 > 3840) {
            this.x = 3840 - 250
          }
          if (this.y < 0) {
            this.y = 0
          }
          if (this.y + 60 > 2160) {
            this.y = 2160 - 60
          }
        }
        const stopFn = evt => {
          if (this.selected) {
            this.$emit('stopped')
          } else {
            if ((totalMoved.x > 0 || totalMoved.y > 0) && this.folder_id == null) {
              this.$store.dispatch('board/updatePostData', {
                board: this.$store.state.board.current,
                post: this
              })
            }
          }
          this.moving = false

          elem.removeEventListener(events.move, moveFn)
          elem.removeEventListener(events.stop, stopFn)
        }

        requestAnimationFrame(updateFn)
        moveFn(evt)

        elem.addEventListener(events.move, moveFn)
        elem.addEventListener(events.stop, stopFn)
      }
    },
    startTouchMove (evt) {
      if (
        (this.$store.state.board.current.mode === 'libre' ||
          this.$router.currentRoute.name === 'animer') &&
        (this.post.folder_id === undefined || this.post.folder_id === null) &&
        (!evt.target.classList.contains('disableDrag'))
      ) {
        const elem = evt.currentTarget.closest('svg')
        const getPos = this.getTouchPos
        const dif = {}

        this.posBeforeMove.x = this.x
        this.posBeforeMove.y = this.y

        dif.x =
          evt.touches[0].clientX -
          document.getElementById('svgBoard').getBoundingClientRect().left -
          this.x
        dif.y =
          evt.touches[0].clientY -
          document.getElementById('svgBoard').getBoundingClientRect().top -
          this.y

        this.moving = true
        // const point = elem.createSVGPoint()
        const updateFn = () => {
          if (this.moving) requestAnimationFrame(updateFn)
        }
        const events = {
          move: 'touchmove',
          stop: 'touchend'
        }
        const moveFn = evt => {
          getPos(evt, this, dif)
          // if (this.selected) {
          //   let movedDist = this.getDistMoved()
          //   if (movedDist) {
          //     movedDist.id = this.id
          //     this.$emit('moving', movedDist)
          //   }
          // }

          if (this.x < 0) {
            this.x = 0
          }
          if (this.x + 250 > 3840) {
            this.x = 3840 - 250
          }
          if (this.y < 0) {
            this.y = 0
          }
          if (this.y + 60 > 2160) {
            this.y = 2160 - 60
          }
        }
        const stopFn = evt => {
          if (this.selected) {
            this.$emit('stopped')
          } else {
            this.$store.dispatch('board/updatePostData', {
              board: this.$store.state.board.current,
              post: this
            })
          }
          this.moving = false
          elem.removeEventListener(events.move, moveFn)
          elem.removeEventListener(events.stop, stopFn)
        }

        requestAnimationFrame(updateFn)
        moveFn(evt)

        elem.addEventListener(events.move, moveFn)
        elem.addEventListener(events.stop, stopFn)
        evt.preventDefault()
      }
    },
    getMousePos (mouseEvent, point, dif) {
      this.clientX = mouseEvent.clientX
      this.clientY = mouseEvent.clientY

      var posX = this.clientX - document.getElementById('svgBoard').getBoundingClientRect().left - dif.x
      var posY = this.clientY - document.getElementById('svgBoard').getBoundingClientRect().top - dif.y
      point.x = posX
      point.y = posY
    },
    getTouchPos (evt, point, dif) {
      this.clientX = evt.touches[0].clientX
      this.clientY = evt.touches[0].clientY
      var posX = evt.touches[0].clientX - document.getElementById('svgBoard').getBoundingClientRect().left - dif.x
      var posY = evt.touches[0].clientY - document.getElementById('svgBoard').getBoundingClientRect().top - dif.y
      point.x = posX
      point.y = posY
    }
  }
}

</script>

<style scoped>
#sheetList {
  background: #fff;
  margin: 5px;
  position: absolute;
  top: 25px;
  font-size: 14px;
  left: 120px;
  text-align: left;
  max-height: 160px;
  min-width: 120px;
  overflow-x: auto;
}

.touchActionNone {
  touch-action: none;
}

.groupPostit {
  overflow: visible;
}

.sheetListItem {
  width: 100%;
  border: 1px solid #3e6a99;
  padding: 5px;
  font-size: 13px;
}
#menuContainer {
  max-width: 125px;
  background: white;
  border-radius: 5px;
  border: 1px solid #3e6a99;
}
#changeSheet {
  width: 160px;
  padding: 8px;
  margin: -10px;
}
#changeSheet > .menuItem > .rightAlign {
  margin-top: 2px;
}
#delete > .rightAlign {
  margin: 0px;
  padding: 10px;
  border-radius: 50%;
}
.menuItem:hover {
  color: black;
  font-weight: 500;
}
.menuItem {
  cursor: pointer;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  font-size: 13px;
  text-align: left;
  height: 20px;
  margin: 3px 5px;
}
.rightAlign {
  text-align: right;
}

.postcontainer {
  background-color: black !important;
  z-index: 2000;
}
.move {
  transition: all 0s;
}
text {
  pointer-events: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.postit {
  cursor: grab;
}

.iconPic {
  height: 16px;
  width: auto;
}

#toggleMenuIcon {
  padding: 5px;
  box-sizing: content-box;
}

#toggleMenuIconBackground {
  width: 100%;
  height: 100%;
}

.noCursor {
  cursor: default;
}
.black {
  color: black !important;
  background-color: black !important;
  stroke: black !important;
}

.deletepostbutton:hover {
  cursor: pointer;
}
.editbutton {
  color: black;
  cursor: pointer;
  width: 20px;
  height: 20px;
}
.linkEditButton {
  color: black;
  cursor: pointer;
  width: 18px;
  height: 18px;
}
.hide {
  visibility: hidden;
}
.likebutton {
  color: black;
  cursor: pointer;
  width: 20px;
  height: 20px;
}
.likebutton:hover {
  cursor: pointer;
  /*box-shadow:0 10px 50px rgba(0,0,0,0.35);
    transform: scale(1.1);*/
}

#addPhoto {
  height: 15px;
  width: auto;
  margin: 2px auto 0px;
}
.non_active {
  opacity: 0.3;
  pointer-events: none;
}

#likesGroup {
  cursor: pointer;
}

#likesGroupBackground {
  /* background: green; */
  width: 100%;
  height: 100%;
}

.thumbsUpBlack {
  height: 20px;
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/post/post.vue